import { cn } from '../../utils'
import { ModalVariant } from './Modal.types'

export const getButtonStyle = () => {
    return 'hover:bg-background-hover-light inline-flex h-10 w-10 items-center justify-center gap-2.5 rounded-full p-1.5 shadow-light'
}

export const getModalClass = (
    isOpen: boolean,
    isDnD?: boolean,
    variant?: ModalVariant
) => {
    const effectiveVariant = variant || 'auto'

    const baseClasses = 'flex flex-col rounded-2xl overflow-hidden'
    const animation = isOpen ? 'animate-fade-in' : 'animate-fade-out'

    if (isDnD) {
        return cn(
            baseClasses,
            animation,
            'fixed xl:right-[5%] 2xl:right-[10%] top-2 w-full xl:max-w-[90svw] 2xl:max-w-[75svw]'
        )
    }

    // w-[calc(100%_-_1.5rem)] keeps a 0.75rem gutter on each side so the modal
    // never touches the viewport edges on small screens. max-w-md still caps it
    // on larger screens, and large modals override the width via min-w.
    const centeredClasses =
        'fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 px-4 sm:px-10 py-2 w-[calc(100%_-_1.5rem)] max-w-md max-h-[90vh] bg-background-base shadow-modal'

    const bottomSheetClasses =
        'fixed bottom-0 left-0 right-0 w-full rounded-t-2xl rounded-b-none px-4 sm:px-10 py-2 max-h-[85vh] bg-background-base shadow-modal'

    // Auto variant: max-w-md constrains base; large modals override via min-w which wins in CSS.
    // w-[calc(100%_-_1.5rem)] keeps a 0.75rem gutter each side so the modal never
    // touches the viewport edges on small screens.
    const autoClasses =
        'fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 px-4 sm:px-10 py-2 w-[calc(100%_-_1.5rem)] max-w-md max-h-[90vh] bg-background-base shadow-modal sm:rounded-2xl'

    switch (effectiveVariant) {
        case 'centered':
            return cn(baseClasses, animation, centeredClasses)
        case 'bottom-sheet':
            return cn(baseClasses, animation, bottomSheetClasses)
        case 'auto':
            return cn(baseClasses, animation, autoClasses)
    }
}

export const getOverlayClass = (isOpen: boolean) => {
    return cn(
        'modal-overlay-blur fixed inset-0',
        `${isOpen ? 'animate-fade-in' : 'animate-fade-out'}`
    )
}
